// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let AssessmentView
require("./styles/assessment.css")

import AssessmentForUser from "assessments/models/assessment-for-user"
import QuestionDeckView from "assessments/show/views/question-deck"
import Assessment from "content/assessment/models/assessment"

export default AssessmentView = (function () {
  AssessmentView = class AssessmentView extends (
    require("lib/static-shim").default(require("lib/core/layout").default)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/assessment.html")

      this.prototype.regions = { assessmentRegion: ".assessment-container" }

      this.prototype.behaviors = {
        ConnectStore: {
          store: "step",
          events: {
            "change:content"() {
              if (
                !(this.options != null ? this.options.isReview : undefined) &&
                this.stepStore != null &&
                !this.stepStore.getState().is_reseting_completion
              ) {
                return this.render()
              }
            }
          }
        }
      }
    }

    onBeforeRender() {
      // welcome to hack city
      let data
      const { content } = this.stepStore.getState()
      // @options.isReview should only be set for admin previewing completion
      if (
        __guard__(
          content != null ? content.assessment : undefined,
          (x) => x.questions
        ) &&
        !(this.options != null ? this.options.isReview : undefined)
      ) {
        data = content
      } else {
        data = this.options != null ? this.options.data : undefined
      }
      if (data) {
        // avoid mutating!
        data = _.clone(data)
        if (data.method === "assessment_editor") {
          let isReview =
            __guard__(
              this.stepStore.getState().completion,
              (x1) => x1.progress
            ) === 1
          // Let isReview option take precedence
          isReview =
            (this.options != null ? this.options.isReview : undefined) ||
            isReview
          this.model = new AssessmentForUser(data, { isReview })
          return this.model.parseData(data)
        } else {
          return (this.model = new Assessment(data))
        }
      }
    }

    onRender() {
      this.$el.addClass(`content-view-${this.model.get("type")}`)
      this._onShowAssessment()
    }

    serializeData() {
      const data = super.serializeData()
      data.assessment = data.assessment
      return data
    }

    _onShowAssessment() {
      if (this.model.get("method") === "assessment_editor") {
        const deck = new QuestionDeckView({ model: this.model })
        this.listenTo(deck, "assessment:completed", this._onAssessmentCompleted)
        return this.assessmentRegion.show(deck)
      }
    }

    _onAssessmentCompleted() {
      if (!this.model.get("is_complete")) {
        // bubble up
        this.trigger("assessment:completed", this)
      }
      this.model.set("is_complete", true)
      // Hack, trying to prevent setting completed
      if (!this.stepStore.getState().is_reseting_completion) {
        // handleLegacyContentCompletion not needed or present when in certain cases (i.e. in CompletionFeedbackPanel )
        this.options.handleLegacyContentCompletion &&
          this.options.handleLegacyContentCompletion(
            false /* isCompletionDisabled */
          )
      }
    }
  }
  AssessmentView.initClass()
  return AssessmentView
})()
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
